import React from "react";
const FormBuilderFormInterfaceLine = ({ item }) => {
  return /* @__PURE__ */ React.createElement("hr", { className: item.class });
};
FormBuilderFormInterfaceLine.displayName = "FormBuilderFormInterfaceLine";
export default React.memo(FormBuilderFormInterfaceLine);
